import React from "react";
import Button from "@components/Button";
import RewardCoin from "@assets/images/profile/reward-coin.svg";
import SuccessQuiz from "@assets/images/mission-center/chicken-quiz-success.png";
import SuccessFeedback from "@assets/images/mission-center/chicken-feedback-success.png";
import { IRouterProps } from "@Interface/Login";
import withRouter from "@common/withRouter";
import LinePoint from "@assets/images/home/line-points-icon.svg";
import PageHeader from "@components/PageHeader";

export interface ISuccessProps {
  content: "quiz" | "feedback";
  pageTitle?: string;
  heading: string;
  subtitle?: string;
  rewardAmount: number;
  lineUrl?: string;
  earnedLabel?: string;
  rewardCoinLabel?: string;
  footerText?: string;
  primaryLabel: string;
  secondaryLabel?: string;
  imageAlt?: string;
  classNames?: string;
  dataLayerSubmit?: (key: string) => void;
}

const SuccessPopup: React.FC<ISuccessProps & IRouterProps> = ({ router, ...props }) => {
  const { content,
    pageTitle,
    heading, 
    subtitle, 
    rewardAmount, 
    lineUrl,
    earnedLabel = "獲得", 
    rewardCoinLabel = "健康幣", 
    footerText, 
    primaryLabel, 
    secondaryLabel, 
    imageAlt = "", 
    classNames,
    dataLayerSubmit } = props;

  const onPrimary = () => {
    dataLayerSubmit?.('feedback_back_to_rewards_cta_click');
    if (lineUrl) {
      window.open(lineUrl, '_blank');
    } else {
      router.navigate('/rewards');
    }
  }

  const onSecondary = () => {
    dataLayerSubmit?.('feedback_mission_return_cta_click');
    router.navigate('/home')
  }

  return (
    <div
      className={`fixed left-1/2 top-0 z-50 flex h-dvh min-h-dvh w-full -translate-x-1/2 flex-col overflow-hidden bg-white tracking-[2%] ${classNames ?? ""}`}
    >
      <div className="shrink-0">
        <PageHeader title={pageTitle ?? "填寫飲用心得"} />
      </div>
      <div
        className="mx-auto flex min-h-0 w-full max-w-sm flex-1 flex-col items-center justify-evenly overflow-y-auto overscroll-contain p-3 px-4 text-center gap-2"
      >
          <div className="w-full shrink-0">
            <h1 className="w-full text-[2.063rem] font-bold leading-snug text-(--button-green)">{heading}</h1>
            {subtitle ? (
              <p className="w-full text-lg font-medium leading-normal text-(--dark-gray)">{subtitle}</p>
            ) : null}
          </div>

          {content === "quiz" ? (
            <div
              className="flex w-full justify-center"
              role="img"
              aria-label={imageAlt || undefined}
            >
              <img
                src={SuccessQuiz}
                alt={imageAlt}
                className="size-80 object-contain"
              />
            </div>
          ) : content === "feedback" ? (
            <div
              className="flex w-full justify-center"
              role="img"
              aria-label={imageAlt || undefined}
            >
              <img
                src={SuccessFeedback}
                alt={imageAlt}
                className="size-80 object-contain"
              />
            </div>
          ) : null}

          <div className="flex w-full flex-col items-center gap-2">
            <p className="text-lg font-medium text-(--dark-gray)">{earnedLabel}</p>
            {content === "feedback" ? 
              <div className="flex flex-row items-center justify-center gap-2">
                <img src={LinePoint} alt="" className="h-6 w-6 object-contain" />
                <p className="text-lg font-bold text-(--button-green)">
                  LINE POINTS +{rewardAmount}點 
                </p>
                {/* <h6 className="text-(--button-green) font-bold text-sm">(前1,000人)</h6> */}
              </div>
            : 
              <div className="flex flex-row items-center justify-center gap-2">
                <img src={RewardCoin} alt="" className="h-8 w-8 object-contain" />
                <p className="text-2xl font-bold text-(--button-green)">
                  {rewardCoinLabel} +{rewardAmount}
                </p>
              </div>
            }
          </div>

          {footerText ? (
            <p className="w-full px-1 text-sm leading-normal text-(--dark-gray)">{footerText}</p>
          ) : null}

          <div className="flex w-full flex-col gap-2">
            <Button label={primaryLabel} onClick={onPrimary} classNames="py-3 font-bold text-sm" />
            {secondaryLabel ? (
              <Button
                label={secondaryLabel}
                btnType="btn-outline-green"
                onClick={onSecondary}
                classNames="py-3 font-bold text-sm"
              />
            ) : null}
          </div>
      </div>
    </div>
  );
};

export default withRouter(SuccessPopup);
